import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

export interface ProgressBarProps {
  value: number; // 0-100
  showLabel?: boolean;
  label?: string;
  height?: number;
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';
  variant?: 'determinate' | 'indeterminate';
  showPercentage?: boolean;
}

export default function ProgressBar({
  value,
  showLabel = false,
  label,
  height = 6,
  color = 'primary',
  variant = 'determinate',
  showPercentage = true,
}: ProgressBarProps) {
  // Determine color based on value thresholds if using primary
  const getColor = (): typeof color => {
    if (color !== 'primary') return color;

    if (value >= 80) return 'success';
    if (value >= 60) return 'primary';
    if (value >= 40) return 'warning';
    return 'error';
  };

  const finalColor = getColor();

  return (
    <Box sx={{ width: '100%' }}>
      {(showLabel || label) && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="caption" color="text.secondary">
            {label || 'Progress'}
          </Typography>
          {showPercentage && variant === 'determinate' && (
            <Typography variant="caption" fontWeight="bold">
              {Math.round(value)}%
            </Typography>
          )}
        </Box>
      )}
      <LinearProgress
        variant={variant}
        value={variant === 'determinate' ? value : undefined}
        color={finalColor}
        sx={{
          height,
          borderRadius: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
        }}
      />
    </Box>
  );
}
